import { matchPath } from "react-router-dom";

export const HEADER_LAYOUT_PATHS = [
  { path: "/:teamSlug/games", exact: true },
  { path: "/listings/new", exact: true },
  { path: "/listings", exact: true },
  { path: "/orders", exact: true },
  { path: "/dashboard", exact: true },
  { path: "/thankyou/:id", exact: true },
  { path: "/why-us", exact: true },
  { path: "/faqs", exact: true },
  { path: "/legal", exact: true },
  { path: "/how-tos/accept-mobile-transfer", exact: true },
  { path: "/how-tos/mobile-transfer", exact: true },
  { path: "/sell/set-prices", exact: true },
  { path: "/login", exact: true },
  { path: "/account-verification", exact: true },
  { path: "/account", exact: true },
  { path: "/account/password", exact: true },
  { path: "/forgot-password", exact: true },
  { path: "/reset-password", exact: true },
  { path: "/new-password", exact: true },
  { path: "/under-maintenance", exact: true },
  { path: "/email-verification", exact: true },
  { path: "/track-order", exact: true },
];

export function pathnameOnly(path) {
  if (!path || typeof path !== "string") {
    return "";
  }
  return path.split("?")[0].split("#")[0] || "/";
}

export function isHeaderLayoutPath(pathname) {
  const p = pathnameOnly(pathname);
  return HEADER_LAYOUT_PATHS.some((route) => Boolean(matchPath(p, route)));
}

const HOME_LAYOUT_BLOCKLIST = [
  { path: "/sell", exact: true },
  { path: "/signup", exact: true },
  { path: "/blogs", exact: true },
  { path: "/checkout", exact: true },
  { path: "/not-found/", exact: true },
];

export function isHomeLayoutPath(pathname) {
  const p = pathnameOnly(pathname);
  if (isHeaderLayoutPath(p)) {
    return false;
  }
  if (HOME_LAYOUT_BLOCKLIST.some((route) => Boolean(matchPath(p, route)))) {
    return false;
  }
  return Boolean(
    matchPath(p, { path: "/", exact: true }) ||
      matchPath(p, { path: "/:sellerSlug", exact: true })
  );
}

export function staysOnSameLayout(fromPath, toPath) {
  return (
    (isHeaderLayoutPath(fromPath) && isHeaderLayoutPath(toPath)) ||
    (isHomeLayoutPath(fromPath) && isHomeLayoutPath(toPath))
  );
}
